import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";


(function () {
  if (typeof window === "undefined") return;
  const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
  const apply = () =>
    document.documentElement.toggleAttribute("data-motion-reduce", mq.matches);
  apply();

  if (mq.addEventListener) mq.addEventListener("change", apply);
  else (mq as any).addListener(apply);
})();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
